import { render } from "./Footer.vue?vue&type=template&id=4a2562ba"
const script = {}
script.render = render

export default script